import { render, staticRenderFns } from "./TarjetaDatos.vue?vue&type=template&id=48dcdd89&scoped=true&"
import script from "./TarjetaDatos.vue?vue&type=script&lang=js&"
export * from "./TarjetaDatos.vue?vue&type=script&lang=js&"
import style0 from "./TarjetaDatos.vue?vue&type=style&index=0&id=48dcdd89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dcdd89",
  null
  
)

export default component.exports